import { registerLicense } from '@syncfusion/ej2-base';

import React from 'react';
import { render } from 'react-dom';

import { App } from 'app';

import './i18n';
import reportWebVitals from './reportWebVitals';

registerLicense(process.env.REACT_APP_SYNCFUSION_LICENSE_KEY!);

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
